import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icon';
import { useSelector } from 'react-redux';

const SidebarScrollIndicator = ({ sidebarRef, deferredPrompt }) => {
  const [showIndicator, setShowIndicator] = useState(true);
  const [hasProfileLink, setHasProfileLink] = useState(false);
  const accountMode = useSelector(state => state.accountMode);
  const currentUser = useSelector(state => state.currentUser);

  let bottom = 140;

  if (currentUser.isProfileCompleted) {
    if (deferredPrompt && currentUser.paymeLink) {
      bottom = 220;
    } else if (deferredPrompt || currentUser.paymeLink) {
      bottom = 180;
    }
  }

  if (!hasProfileLink) {
    bottom -= 40;
  }

  bottom = `${bottom}px`;

  const scrollToBottom = () => {
    const sidebar = sidebarRef?.current;
    if (!sidebar) return;

    const scrollAmount = window.innerHeight - parseInt(bottom, 10);
    const maxScroll = sidebar.scrollHeight - sidebar.clientHeight;
    const nextScroll = Math.min(sidebar.scrollTop + scrollAmount, maxScroll);

    sidebar.scrollTo({
      top: nextScroll,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    const sidebar = sidebarRef?.current;

    if (!sidebar) return;

    setShowIndicator(sidebar.scrollTop <= 25);

    const handleScroll = () => {
      setShowIndicator(sidebar.scrollTop <= 25);
    };

    sidebar.addEventListener('scroll', handleScroll);

    return () => {
      sidebar.removeEventListener('scroll', handleScroll);
    };
  }, [sidebarRef]);

  useEffect(() => {
    const interval = setInterval(() => {
      const input = document.getElementById('profilelink');
      if (input) {
        setHasProfileLink(!!input.value);
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <button
      className={`sidebar-scroll-indicator ${showIndicator && accountMode !== 'affiliator' ? 'show' : ''}`}
      onClick={scrollToBottom}
      aria-label="Scroll sidebar"
      style={{ bottom: accountMode !== 'affiliator' ? bottom : '0px' }}
    >
      <Icon name="chevron-down" />
    </button>
  );
};

SidebarScrollIndicator.propTypes = {
  sidebarRef: PropTypes.object.isRequired,
  deferredPrompt: PropTypes.object
};

export default SidebarScrollIndicator;
